import { atom, type PrimitiveAtom } from "jotai"
import { type SignupPageAtomInterface, type UserDetailsInterface, type UserProfileDataInterface } from "../commons/commonTypes"
import { defaultMenuAll } from "../../common/commonConstants"
export const idAtom = atom(77)
export const signupPageAtom: PrimitiveAtom<SignupPageAtomInterface> = atom({})
export const userDetailsAtom = atom<UserDetailsInterface | null>(null)
export const userProfileDataAtom: PrimitiveAtom<UserProfileDataInterface> = atom({})
export const maxHeightAtom: PrimitiveAtom<number> = atom(0)
export const clearMenuAtom: PrimitiveAtom<boolean> = atom(false)
export const currentMenuPage: PrimitiveAtom<Record<string, string>> = atom({})

export const setIdAtom = atom(
  () => "",
  (get, set, updatedValue: number) => {
    set(idAtom, updatedValue)
  }
)

export const setSignupPageAtom = atom(
  () => "",
  (get, set, updatedValue: SignupPageAtomInterface) => {
    set(signupPageAtom, updatedValue)
  }
)

export const setUserProfileDataAtom = atom(
  () => "",
  (get, set, updatedValue: UserProfileDataInterface) => {
    set(userProfileDataAtom, updatedValue)
  }
)

export const setCurrentMobileMenuPage = atom(
  () => "",
  (get, set, updatedValue: Record<string, string>) => {
    set(currentMenuPage, updatedValue)
  }
)

export const PreviouslyClickedAtom = atom<string[]>([defaultMenuAll])
export const loginModalOpenAtom = atom<boolean>(false)
